import React from 'react'
import Success from '../assets/img/successEmoji.gif'
import { useNavigate } from "react-router-dom";

const PaymentSuccess = () => {
    const navigate = useNavigate();
    const handleNavigateToHome = () => {
        navigate("/");
    }
    return (
        <div className='flex flex-col justify-center items-center mt-20 text-2xl'><p>Thanh toán Thành công</p>
            <img src={Success} alt="" />
            <div className='mt-4 underline text-bold text-blue-600 cursor-pointer'
            onClick={handleNavigateToHome}
            >
                Trở về trang chủ 
            </div>
        </div>
    )
}

export default PaymentSuccess